import ApiClient from './ApiClient';

class Hdr extends ApiClient {
  constructor() {
    super('hdr', { accountScoped: true });
  }
}

export default new Hdr();
